
import Vue from "vue";
import { AuthService } from "../../services/auth-service";
import { MODULE } from "../../config/modules";
import AppMissingModule from "@/components/common/MissingModule.vue";
import { DossierConfigService } from "@/services/dossier-config-service";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			module: MODULE.VOORRAADBEHEER,
			config: DossierConfigService.getStockScannerConfig(),
			stockLocationConfig: DossierConfigService.getStockLocationConfig(),
		};
	},
	computed: {
		items(): ISelectItem<number>[] {
			let result:ISelectItem<number>[] = [];

			if(!AuthService.hasModule(MODULE.MULTI_VOORRAAD)){
				return result.concat([{
					text: this.stockLocationConfig.getSortedLocationNames()[0],
					value: 1
				} as ISelectItem<number>]);
			}

			return result.concat(this.stockLocationConfig.getSortedLocationNames().map((l:string, i:number) => {
				return {
					text: l,
					value: i + 1
				} as ISelectItem<number>;
			}));
		},
		hasStockModule():boolean {
			return AuthService.hasModule(this.module);
		}
	},
	methods: {
		async onChange(){
			this.config = await DossierConfigService.saveStockScannerConfig(this.config);
		}
	},
	components: {
		AppMissingModule,
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
